.backdrop {
  position: fixed;
  inset: 0;
  background: rgba(10, 11, 13, 0.72);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  z-index: 1000;
}

.dialog {
  position: relative;
  width: 100%;
  max-width: 420px;
  max-height: 90vh;
  overflow-y: auto;
  background: var(--bg-panel);
  border-radius: var(--r-16);
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.close {
  position: absolute;
  top: 12px;
  right: 12px;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: none;
  background: var(--bg-page);
  color: var(--text-primary);
  font-size: 22px;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.title {
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: var(--text-muted);
}

.className {
  font-family: var(--font-display);
  font-weight: 700;
  font-size: 24px;
  margin-top: -6px;
}

.price {
  font-weight: 700;
  font-size: 18px;
  color: var(--accent-text);
}

.notice {
  font-size: 13px;
  color: var(--text-muted);
  background: var(--bg-tint);
  border-radius: var(--r-10);
  padding: 10px 12px;
}

.vehicles {
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 260px;
  overflow-y: auto;
}

.vehicleRow {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px;
  border-radius: var(--r-10);
  border: 1px solid var(--border-2);
  font-size: 15px;
  cursor: pointer;
}
.vehicleRow input {
  width: 18px;
  height: 18px;
  accent-color: var(--accent);
  margin: 0;
  flex-shrink: 0;
}

.vehicleRowDisabled {
  color: var(--text-muted);
  cursor: not-allowed;
  background: var(--bg-tint);
}

.empty {
  font-size: 14px;
  color: var(--text-muted);
  line-height: 1.5;
}

.error {
  font-size: 14px;
  color: var(--danger);
}

.actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 4px;
}

.cancel,
.confirm {
  height: 44px;
  padding: 0 18px;
  border-radius: var(--r-10);
  font-weight: 600;
  font-size: 15px;
}

.cancel {
  border: 1px solid var(--border-4);
  background: var(--bg-panel);
  color: var(--text-primary);
}

.confirm {
  border: none;
  background: var(--accent-strong);
  color: var(--text-on-dark);
}
.confirm:disabled {
  opacity: 0.5;
}
